import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export {
  DISPLAY_TIME_ZONE,
  diffDisplayCalendarDays,
  displayDateKeyFromInput,
  formatDate,
  formatDateMedium,
  formatDateShort,
  formatDateTime,
  formatDateTimeCompact,
  formatDateTimeMedium,
  formatDateLongWithWeekday,
  formatDateWeekdayShort,
  formatDateWithWeekday,
  formatMonthYear,
  getDisplayDateKey,
  parseDisplayDate,
} from "./displayDateTime";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format role for display: DSA → "DSA", OPS → "OPS", others → capitalize first letter
 */
export function formatRoleDisplay(role: string): string {
  const upper = role.toUpperCase();
  if (upper === "DSA" || upper === "OPS") return upper;
  if (role === "licensing_ops") return "Licensing OPS";
  return role.charAt(0).toUpperCase() + role.slice(1);
}
